/**
 * Returns `attributes` without the keys whose value is `undefined`.
 *
 * A surface that only sees part of the session — the booking portal — leaves the rest of an
 * `AnalyticsIdentity` unset. Userflow and Segment merge what they receive onto shared user and
 * company records, so omitting a key leaves the stored value alone while sending one replaces it.
 *
 * Two things this is NOT. It is not a JSON-serialisation nicety: `analytics-next` merges an
 * identify over the browser's persisted traits and transmits the merged set, so a key dropped
 * here still reaches the vendor with whatever that browser last stored. And it only drops
 * `undefined` — `null`, `0`, `false` and `''` are sent, and a vendor reads `null` as a clear.
 * A caller that means "clear this" must therefore send `null`, and a caller that means "I could
 * not resolve this" must send `undefined` rather than an empty string. See `omit-undefined.spec.ts`.
 */
export function omitUndefined<Value>(attributes: Record<string, Value | undefined>): Record<string, Value> {
	const defined: Record<string, Value> = {};

	for (const [key, value] of Object.entries(attributes)) {
		if (value !== undefined) defined[key] = value;
	}

	return defined;
}
